import { useEffect } from 'react';
import PicturesAndVideosSlider from '../../mediaLanding/picturesAndVideosSlider/PicturesAndVideosSlider.js'
import PicturesAndVideosTabs from '../../mediaLanding/picturesAndVideosTabs/PicturesAndVideosTabs.js'
import { END_POINTS } from 'constants/APIConstant.js';
import ReactGA from "react-ga4";

function PicturesAndVideos() {

  
  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/mediaLanding/media", title: "Media Page" });
  }, []);


  return (
    <div>
      <PicturesAndVideosSlider />
      <PicturesAndVideosTabs />
    </div>
  )
}

export default PicturesAndVideos